"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRolloverBalanceCalculationTable = exports.generateRolloverAmount = exports.hideBalanceViewFutureAmount = exports.validateAmount9Digits2Decimals = exports.generateMonthCopyOptions = exports.generateEditOptionsForAnnualTable = exports.getBudgetViewStateObject = exports.getKeyFutureMonthsVisibility = exports.getAmountColor = exports.getIterableCells = exports.hideDetailsViewCells = exports.extractDetailsForTracker = exports.hideToDateColumn = exports.getIterableMonthCells = exports.getMonthlyCellSxProps = exports.getHighlightColor = exports.getProgressColor = exports.budgetOptions = void 0;
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const Box_1 = __importDefault(require("@mui/material/Box"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const Height_1 = __importDefault(require("@mui/icons-material/Height"));
const Upgrade_1 = __importDefault(require("@mui/icons-material/Upgrade"));
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
const constants_1 = require("./constants");
const budgetOptions = ({ isToDateColumnEnabled, handleShowToDateSetting, }) => ({
    label: 'Budget Options',
    items: [
        {
            label: 'View Options',
            items: [
                {
                    label: 'Show to-date column in annual view',
                    leftIcon: (<Box_1.default sx={{ display: 'flex', alignItems: 'center', my: '-6px' }}>
              <QCheckbox_1.default checked={isToDateColumnEnabled} disableRipple style={{ pointerEvents: 'none' }} size={20}/>
            </Box_1.default>),
                    callback: () => handleShowToDateSetting(),
                },
            ],
        },
    ],
});
exports.budgetOptions = budgetOptions;
const getProgressColor = (balanceAmount, redColor, greenColor) => balanceAmount < 0 ? redColor : greenColor;
exports.getProgressColor = getProgressColor;
const getHighlightColor = (numMonth, currentMonth, currentYear, budgetEndYear, color, isToDate = false) => !isToDate && currentMonth === numMonth && budgetEndYear >= currentYear && color;
exports.getHighlightColor = getHighlightColor;
const getMonthlyCellSxProps = (startDate, currentMonth, currentYear, budgetEndYear, color, border, isToDate = false, isSelected = false, colorSelectedRow = '') => {
    const monthFromStartDate = luxon_1.DateTime.fromISO(startDate.toString()).month;
    return {
        border,
        p: 0,
        backgroundColor: isSelected
            ? colorSelectedRow
            : (0, exports.getHighlightColor)(monthFromStartDate, currentMonth, currentYear, budgetEndYear, color, isToDate),
    };
};
exports.getMonthlyCellSxProps = getMonthlyCellSxProps;
const arrangeMonthlyCellsOrder = (arrMonths, currentMonth, budgetEndMonth, isToDateEnabled) => {
    const pushMonthCells = [];
    if (isToDateEnabled) {
        arrMonths.forEach((objMonth) => {
            if (objMonth.number === currentMonth && currentMonth !== budgetEndMonth) {
                pushMonthCells.push(objMonth, {
                    number: -1,
                    shortName: 'To Date',
                    name: 'To Date',
                });
            }
            else {
                pushMonthCells.push(objMonth);
            }
        });
    }
    else {
        pushMonthCells.push(...arrMonths);
    }
    return pushMonthCells;
};
const getIterableMonthCells = (budgetStartMonth, currentMonth, budgetEndMonth, budgetStartYear, budgetEndYear, isToDateEnabled = false) => {
    // IF it's staring from Jan month, then it's normal process
    if (budgetStartMonth === 1) {
        return arrangeMonthlyCellsOrder(constants_1.BUDGET_ANNUAL_MONTHS, currentMonth, budgetEndMonth, isToDateEnabled);
    }
    // Otherwise, special treatment
    const passedMonths = constants_1.BUDGET_ANNUAL_MONTHS.slice(0, budgetStartMonth - 1)
        .map((objMonth) => (Object.assign(Object.assign({}, objMonth), { year: budgetEndYear })));
    const futureMonths = constants_1.BUDGET_ANNUAL_MONTHS.slice(budgetStartMonth - 1)
        .map((objMonth) => (Object.assign(Object.assign({}, objMonth), { year: budgetStartYear })));
    return arrangeMonthlyCellsOrder([...futureMonths, ...passedMonths], currentMonth, budgetEndMonth, isToDateEnabled);
};
exports.getIterableMonthCells = getIterableMonthCells;
const hideToDateColumn = (isToDateColumnEnabled, isToDate, currentMonth, budgetEndMonth) => isToDate && (!isToDateColumnEnabled || currentMonth === budgetEndMonth);
exports.hideToDateColumn = hideToDateColumn;
const extractDetailsForTracker = (sharedPreferences) => {
    const trackingDetails = {};
    if (sharedPreferences && sharedPreferences.budgetOptions && sharedPreferences.budgetOptions.lastViewedBudgetId) {
        const { lastViewedBudgetId } = sharedPreferences.budgetOptions;
        if (sharedPreferences && sharedPreferences.webApp && sharedPreferences.webApp.budgetOptions && sharedPreferences.webApp.budgetOptions.viewState) {
            const { viewState } = sharedPreferences.webApp.budgetOptions;
            const lastViewedBudgetToTrack = viewState[lastViewedBudgetId];
            if (lastViewedBudgetToTrack) {
                const { viewType, subViewType } = lastViewedBudgetToTrack;
                trackingDetails.budgetView = viewType;
                if (viewType === constants_1.BUDGET_VIEWS.annual.key) {
                    trackingDetails.annualViewType = constants_1.BUDGET_ANNUAL_SUBVIEWS[subViewType].label;
                }
            }
        }
    }
    return trackingDetails;
};
exports.extractDetailsForTracker = extractDetailsForTracker;
const hideDetailsViewCells = (prefShowFutureMonthDetails, { isToDate, startDate }, annualSubView, currentMonth, currentYear) => annualSubView === constants_1.BUDGET_ANNUAL_SUBVIEWS.details.key && !prefShowFutureMonthDetails && !isToDate
    && ((Number(startDate === null || startDate === void 0 ? void 0 : startDate.month) > currentMonth && (startDate === null || startDate === void 0 ? void 0 : startDate.year) === currentYear) || Number(startDate === null || startDate === void 0 ? void 0 : startDate.year) > currentYear);
exports.hideDetailsViewCells = hideDetailsViewCells;
const getIterableCells = (monthlyAmounts, budgetEndMonth, currentMonth, currentYear, annualSubView, prefShowFutureMonthDetails, isDetailsView = false, isToDateEnabled = false) => {
    const arrCellsObjects = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const objMonth of monthlyAmounts) {
        if ((0, exports.hideToDateColumn)(isToDateEnabled, objMonth.isToDate, objMonth.startDate.month, budgetEndMonth)) {
            // eslint-disable-next-line no-continue
            continue;
        }
        if ((0, exports.hideDetailsViewCells)(prefShowFutureMonthDetails, objMonth, annualSubView, currentMonth, currentYear)) {
            arrCellsObjects.push(Object.assign(Object.assign({}, objMonth), { amount: objMonth.budgetAmount }));
        }
        else if (!isDetailsView || objMonth.isToDate) {
            arrCellsObjects.push(objMonth);
        }
        else {
            arrCellsObjects.push(Object.assign(Object.assign({}, objMonth), { amount: objMonth.budgetAmount }), Object.assign(Object.assign({}, objMonth), { amount: objMonth.actualAmount }), Object.assign(Object.assign({}, objMonth), { amount: objMonth.balanceAmount, isBalanceAmount: true }));
        }
    }
    return arrCellsObjects;
};
exports.getIterableCells = getIterableCells;
const getAmountColor = (viewType, amount, colorActual, colorBalance, isBalanceAmount = false, isToDate = false, isTotalColumn = false) => {
    let colorAmount = 'inherit';
    if (isToDate || isTotalColumn) {
        return amount < 0 ? colorBalance : colorAmount;
    }
    if (viewType === constants_1.BUDGET_ANNUAL_SUBVIEWS.actual.key && !isTotalColumn) {
        colorAmount = colorActual;
    }
    else if ((isBalanceAmount || isToDate || viewType === constants_1.BUDGET_ANNUAL_SUBVIEWS.balance.key) && amount < 0) {
        colorAmount = colorBalance;
    }
    return colorAmount;
};
exports.getAmountColor = getAmountColor;
const getKeyFutureMonthsVisibility = (annualSubView) => `${annualSubView}_isHiddenFutureMonths`;
exports.getKeyFutureMonthsVisibility = getKeyFutureMonthsVisibility;
const getBudgetViewStateObject = (id, name, viewType, subViewType, showFutureMonthDetails, changedFutureDetails = false) => {
    const futureMonthsVisibility = changedFutureDetails ? !showFutureMonthDetails : showFutureMonthDetails;
    return {
        budgetOptions: {
            viewState: {
                [id]: Object.assign({ name,
                    viewType,
                    subViewType }, (typeof showFutureMonthDetails === 'boolean' && { [(0, exports.getKeyFutureMonthsVisibility)(subViewType)]: futureMonthsVisibility })),
            },
        },
    };
};
exports.getBudgetViewStateObject = getBudgetViewStateObject;
const getStringForOptions = (month, budgetStartYear, budgetEndYear) => {
    var _a;
    return ({
        monthShortName: (_a = constants_1.BUDGET_ANNUAL_MONTHS[month - 1]) === null || _a === void 0 ? void 0 : _a.shortName,
        suffixFY: budgetStartYear === budgetEndYear ? '' : '(FY)',
    });
};
const generateEditOptionsForAnnualTable = (monthSelected, budgetStartYear, budgetEndYear, handleApplyAction, handleEditYearlyAction) => {
    const { monthShortName, suffixFY } = getStringForOptions(monthSelected.month, budgetStartYear, budgetEndYear);
    return [
        {
            label: `Apply ${monthShortName} budget forward to the end of ${budgetEndYear} ${suffixFY}`,
            value: constants_1.BUDGET_ANNUAL_COPY_OPTIONS.restOfYear,
            action: handleApplyAction,
            icon: <Upgrade_1.default sx={{ transform: 'rotate(90deg)' }}/>,
        },
        {
            label: `Apply ${monthShortName} budget to all of ${budgetEndYear} ${suffixFY}`,
            value: constants_1.BUDGET_ANNUAL_COPY_OPTIONS.wholeYear,
            action: handleApplyAction,
            icon: <Height_1.default sx={{ transform: 'rotate(90deg)' }}/>,
        },
        {
            label: 'Edit yearly budget',
            value: 'editYearlyBudget',
            action: handleEditYearlyAction,
            icon: <Edit_1.default fontSize="small"/>,
        },
        // TODO hide calculate average
        // {
        //   label: 'Calculate average budget',
        //   value: 'calculateAverageBudget',
        //   action: handleCalculateAverageAction,
        //   icon: <SettingsSuggestIcon fontSize="small" />,
        // },
    ];
};
exports.generateEditOptionsForAnnualTable = generateEditOptionsForAnnualTable;
const generateMonthCopyOptions = (monthClicked, budgetStartMonth, budgetEndMonth, budgetStartYear, budgetEndYear, handleMonthCopyAction) => {
    if (!monthClicked) {
        return [];
    }
    const { monthShortName, suffixFY } = getStringForOptions(monthClicked.month, budgetStartYear, budgetEndYear);
    return [
        {
            key: constants_1.BUDGET_ANNUAL_COPY_OPTIONS.restOfYear,
            label: `Copy ${monthShortName} budgets to all future months in ${budgetEndYear} ${suffixFY}`,
            action: handleMonthCopyAction,
            icon: <Upgrade_1.default sx={{ transform: 'rotate(90deg)' }}/>,
            disabled: monthClicked.month === budgetEndMonth,
        },
        {
            key: constants_1.BUDGET_ANNUAL_COPY_OPTIONS.pastMonths,
            label: `Copy ${monthShortName} budgets to all past months in ${budgetEndYear} ${suffixFY}`,
            action: handleMonthCopyAction,
            icon: <Upgrade_1.default sx={{ transform: 'rotate(270deg)' }}/>,
            disabled: monthClicked.month === budgetStartMonth,
        },
        {
            key: constants_1.BUDGET_ANNUAL_COPY_OPTIONS.wholeYear,
            label: `Copy ${monthShortName} budgets to all months in ${budgetEndYear} ${suffixFY}`,
            action: handleMonthCopyAction,
            icon: <Height_1.default sx={{ transform: 'rotate(90deg)' }}/>,
        },
    ];
};
exports.generateMonthCopyOptions = generateMonthCopyOptions;
const validateAmount9Digits2Decimals = (value) => /^[+ -]?[0-9]{0,9}([.][0-9]{0,2})?$/.test(value);
exports.validateAmount9Digits2Decimals = validateAmount9Digits2Decimals;
const hideBalanceViewFutureAmount = (prefShowFutureMonthDetails, { isToDate, startDate }, annualSubView, currentMonth, currentYear, budgetEndMonth, budgetEndYear, isSummaryCell = false) => {
    let hideCell = !prefShowFutureMonthDetails && annualSubView === constants_1.BUDGET_ANNUAL_SUBVIEWS.balance.key;
    if (isSummaryCell) {
        // Not to hide the cell when the budget end is equal the current month and year.
        if (budgetEndMonth === currentMonth && budgetEndYear === currentYear) {
            hideCell && (hideCell = false);
        }
        return hideCell;
    }
    hideCell && (hideCell = !isToDate
        && (((startDate === null || startDate === void 0 ? void 0 : startDate.month) > currentMonth && (startDate === null || startDate === void 0 ? void 0 : startDate.year) === currentYear)
            || (startDate === null || startDate === void 0 ? void 0 : startDate.year) > currentYear));
    return hideCell;
};
exports.hideBalanceViewFutureAmount = hideBalanceViewFutureAmount;
const generateRolloverAmount = (budgetItem) => { var _a, _b; return -1 * ((_b = (_a = budgetItem === null || budgetItem === void 0 ? void 0 : budgetItem.rolloverOverrideAmount) !== null && _a !== void 0 ? _a : budgetItem === null || budgetItem === void 0 ? void 0 : budgetItem.calculatedRolloverAmount) !== null && _b !== void 0 ? _b : 0); };
exports.generateRolloverAmount = generateRolloverAmount;
const generateRolloverBalanceCalculationTable = (monthlyDetails) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const selectedDate = luxon_1.DateTime.fromISO((_a = monthlyDetails === null || monthlyDetails === void 0 ? void 0 : monthlyDetails.objMonthlyAmounts) === null || _a === void 0 ? void 0 : _a.startDate);
    const budgetItemOfSelectedDate = (_c = (_b = monthlyDetails === null || monthlyDetails === void 0 ? void 0 : monthlyDetails.budgetItem) === null || _b === void 0 ? void 0 : _b.budgetItems) === null || _c === void 0 ? void 0 : _c.find((budgetItemIterated) => luxon_1.DateTime.fromISO(budgetItemIterated.startDate).month === selectedDate.month);
    const isIncome = ((_d = monthlyDetails === null || monthlyDetails === void 0 ? void 0 : monthlyDetails.budgetItem) === null || _d === void 0 ? void 0 : _d.negate) > 0;
    const rolloverAmount = (0, exports.generateRolloverAmount)(budgetItemOfSelectedDate);
    return [{
            key: 'Rollover',
            keyName: 'rolloverAmount',
            datedOn: 'Last Month',
            operation: undefined,
            value: rolloverAmount,
            edit: true,
        },
        {
            key: 'Budget',
            keyName: 'budgetAmount',
            datedOn: 'This Month',
            operation: isIncome ? '-' : '+',
            value: (_e = monthlyDetails === null || monthlyDetails === void 0 ? void 0 : monthlyDetails.objMonthlyAmounts) === null || _e === void 0 ? void 0 : _e.budgetAmount,
            edit: false,
        },
        {
            key: 'Actual',
            keyName: 'actualAmount',
            datedOn: 'This Month',
            operation: isIncome ? '+' : '-',
            value: (_f = monthlyDetails === null || monthlyDetails === void 0 ? void 0 : monthlyDetails.objMonthlyAmounts) === null || _f === void 0 ? void 0 : _f.actualAmount,
            edit: false,
        },
        {
            key: 'Balance',
            keyName: 'balanceAmount',
            datedOn: undefined,
            operation: '=',
            value: (_g = monthlyDetails === null || monthlyDetails === void 0 ? void 0 : monthlyDetails.objMonthlyAmounts) === null || _g === void 0 ? void 0 : _g.balanceAmount,
            edit: false,
        }];
};
exports.generateRolloverBalanceCalculationTable = generateRolloverBalanceCalculationTable;
